import { render } from "./AddInsuranceCompany.vue?vue&type=template&id=c6c12c58&scoped=true"
import script from "./AddInsuranceCompany.vue?vue&type=script&lang=js"
export * from "./AddInsuranceCompany.vue?vue&type=script&lang=js"

import "./AddInsuranceCompany.vue?vue&type=style&index=0&id=c6c12c58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c12c58"]])

export default __exports__